/**
 * Leaf date-conversion module — since APX-560 (PR-1) a pure re-export shim over
 * the dayjs adapter. `src/helper/date.ts` owns the single implementation of the
 * UTC→timezone / UTC→local conversion pair (`utcToZoned` / `utcToBrowserLocal`);
 * this module keeps the legacy names alive so the three historical import paths
 * (utils.ts, time-utils.ts, and this file) all resolve to the SAME function
 * objects — the unification golden pins that referential identity.
 *
 * This module must stay a LEAF: a bare re-export with no logic, so it can never
 * participate in an import cycle. It is removed in PR-6 with the last legacy import.
 */
export {
  utcToBrowserLocal as convertUtcToLocal,
  utcToZoned as convertUtcToRelevantTimezone,
} from './date';
